import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerTokenService } from '../../services/server-token.service';
import {
  CadaraCompanyMatch,
  CadaraFacilityMapPage,
} from './cadara-settings.models';

// Region scope comes from the token on the server.
@Injectable({ providedIn: 'root' })
export class CadaraSettingsService {
  private readonly base = 'snfs/cadara';

  constructor(private server: ServerTokenService) {}

  facilityMap(): Observable<CadaraFacilityMapPage> {
    return this.server.getWithToken<CadaraFacilityMapPage>(`${this.base}/facility-map`);
  }

  // null = no Cadara company; 'auto' = drop the override, back to the name match.
  saveFacilityMap(facilityId: number, companyId: number | null | 'auto'): Observable<void> {
    return this.server.putWithToken<void>(`${this.base}/facility-map/${facilityId}`, { companyId });
  }

  companyMatch(companyId: number): Observable<CadaraCompanyMatch> {
    return this.server.getWithToken<CadaraCompanyMatch>(`${this.base}/companies/${companyId}/match`);
  }
}
